import React, { useEffect, useRef, useState } from "react";
import { audio } from "../../game/audio";

export const HallucinationOverlay = ({ whisper, onDismiss }) => {
  const [visible, setVisible] = useState(false);
  const spokenRef = useRef("");

  useEffect(() => {
    if (whisper) {
      setVisible(true);
      const t = setTimeout(() => {
        setVisible(false);
        setTimeout(onDismiss, 800);
      }, 8000);
      return () => clearTimeout(t);
    } else {
      spokenRef.current = "";
    }
  }, [whisper, onDismiss]);

  // Speak the whisper text once it stops changing (LLM stream finished)
  useEffect(() => {
    if (!whisper || !whisper.text) return;
    if (whisper.loading) return;
    if (whisper.text === spokenRef.current) return;
    spokenRef.current = whisper.text;
    // Slight delay to feel like it fades in
    const t = setTimeout(() => audio.speak(whisper.text, { whisper: true }), 250);
    return () => clearTimeout(t);
  }, [whisper]);

  if (!whisper) return null;
  return (
    <div
      className={`fixed inset-0 z-40 pointer-events-none flex items-center justify-center transition-opacity duration-700 ${visible ? "opacity-100" : "opacity-0"}`}
      data-testid="hallucination-overlay"
    >
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at center, rgba(80,0,0,0.35), rgba(3,3,3,0.7) 70%)" }} />
      <div className="relative max-w-xl px-8 text-center">
        <p
          className="whisper text-3xl md:text-4xl leading-tight animate-tremor"
          data-testid="hallucination-text"
          style={{ transform: `rotate(${(Math.random() * 2 - 1).toFixed(2)}deg)` }}
        >
          {whisper.loading && whisper.text.length === 0 ? "..." : whisper.text}
        </p>
      </div>
    </div>
  );
};
